/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ActionStatus {
  Pending = 'pending',
  Authorized = 'authorized',
  Denied = 'denied',
  Expired = 'expired'
}
